import React, { useCallback } from "react";
import { ChoiceList, IndexFilters, IndexFiltersMode, Modal } from "@shopify/polaris";
import type { ChoiceListProps, IndexFiltersProps } from "@shopify/polaris";

export interface ColumnSelection {
  readonly choices: ChoiceListProps["choices"];
  readonly selected: string[];
  readonly onChange: (selected: string[]) => void;
}

export default function TableFilters({
  columnSelection,
  ...props
}: IndexFiltersProps & { readonly columnSelection?: ColumnSelection }): React.JSX.Element {
  const { mode, setMode } = props;
  const handleClose = useCallback((): void => {
    setMode(IndexFiltersMode.Default);
  }, [setMode]);

  return (
    <>
      <IndexFilters {...props} showEditColumnsButton={Boolean(columnSelection)} />
      {columnSelection ? (
        <Modal
          onClose={handleClose}
          open={mode === IndexFiltersMode.EditingColumns}
          primaryAction={{ content: "Done", onAction: handleClose }}
          title="Columns"
        >
          <Modal.Section>
            <ChoiceList allowMultiple {...columnSelection} title="Visible columns" />
          </Modal.Section>
        </Modal>
      ) : null}
    </>
  );
}
